var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAssist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI Assist 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4936 31.7338C15.9926 32.7554 17.4059 32.7554 17.9049 31.7338L19.6546 28.1518C20.1185 27.2021 20.7869 26.3746 21.6086 25.7328L24.8632 23.1906C25.577 22.633 25.577 21.5261 24.8632 20.9685L21.6086 18.4263C20.7869 17.7844 20.1185 16.957 19.6546 16.0073L17.9049 12.4253C17.4059 11.4037 15.9926 11.4037 15.4936 12.4253L13.7439 16.0073C13.28 16.957 12.6117 17.7844 11.7899 18.4263L8.53532 20.9685C7.82156 21.5261 7.82156 22.633 8.53532 23.1906L11.7899 25.7328C12.6117 26.3746 13.28 27.2021 13.7439 28.1518L15.4936 31.7338ZM28.0671 15.0052C28.4432 15.7906 29.5287 15.7906 29.9046 15.0052C30.25 14.2841 30.7501 13.6538 31.3671 13.1622L31.5316 13.0312C32.1561 12.5335 32.1561 11.5608 31.5316 11.0631L31.3671 10.932C30.7501 10.4405 30.25 9.81017 29.9046 9.08909C29.5287 8.30364 28.4432 8.30364 28.0671 9.08909C27.7219 9.81017 27.2217 10.4405 26.6049 10.932L26.4403 11.0631C25.8158 11.5608 25.8158 12.5335 26.4403 13.0312L26.6049 13.1622C27.2217 13.6538 27.7219 14.2841 28.0671 15.0052Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssist);
export default __webpack_public_path__ + "static/media/AI Assist.9ddca9a8b397d65898ada642999bc09a.svg";
export { ForwardRef as ReactComponent };